import { IMytaverseFile } from '@interfaces/file';
import { Gender } from '@avaturn/sdk';
import { AvaturnChangeAsset } from '@interfaces/avatar';
export interface IAvaturnTokens {
  ek: string;
  dnata: string;
  marhaba: string;
  ekas: string;
  selfHosted: string;
  mytaverse: string;
}
export interface IAvaturnData {
  avaturnId: string;
  avatarId: string;
  avaturnAvatarId: string;
  avatarUrl?: string | null;
  uploadUrl?: string;
  metadata?: IAvaturnMetadata;
  photoUrls?: {
    [key: string]: IMytaverseFile | null;
  };
  tags?: string[];
  status?: AvaturnStatuses;
  changeAssets?: AvaturnChangeAsset | null;
  assetId?: string;
}
export interface INewAvaturnData {
  avaturnId: string;
  avatarId: string;
  isNew?: boolean;
}

export enum AvaturnStatuses {
  ACTIVE = 'ACTIVE',
  LIMITED = 'LIMITED',
  CREATING = 'CREATING',
  EXPORTING = 'EXPORTING',
  FAILED = 'FAILED',
  FAILED_CREATION = 'FAILED_CREATION',
  FAILED_EXPORTING = 'FAILED_EXPORTING',
  WH_AVATAR_READY = 'WH_AVATAR_READY',
}

export interface IAvaturnUpdate {
  status?: AvaturnStatuses;
  tags?: string[];
  renderId?: string;
  assetId?: string;
}

export interface IExportAvaturn {
  url: string;
  urlType?: 'dataURL' | 'httpURL';
  avaturnId: string;
  avatarId: string;
  sessionId?: string;
  avatarSupportsFaceAnimations?: boolean;
  bodyId?: string;
  gender: Gender;
  brand: string;
}
interface AssetSlot {
  id: string;
}

interface AssetSlotWithColor extends AssetSlot {
  color: string;
}

interface BoneScale {
  head: number; // Default is 0
  arms: number; // Default is 0
  chest: number; // Default is 0
}

interface IAvaturnMetadata {
  assets: {
    clothing: AssetSlot | null;
    hair_and_headwear: AssetSlotWithColor | null;
    eyewear: AssetSlotWithColor | null;
    footwear: AssetSlot | null;
  };
  body: 'body_0' | 'body_1' | 'body_2' | 'body_3' | 'body_4'; // Avatar body type
  age: '3-6' | '7-12' | '13-16' | 'adult'; // Age with default 'adult'
  metadata: Record<string, string>; // Arbitrary key-value pairs (10 max, 500 chars max per value)
  bone_scale: BoneScale;
  skin_tone_correction: number; // Default is 0
  eye_texture:
    | 'light_green'
    | 'amber'
    | 'blue'
    | 'blue_gray_yellow'
    | 'brown'
    | 'dark_brown'
    | 'gray'
    | 'gray_green'
    | 'green'
    | 'light_gray'; // Eye color with default 'brown'
}

export enum GenderType {
  FEMALE = 'female',
  MALE = 'male',
}

export enum SkinToneType {
  LIGHT = '1',
  MEDIUM_LIGHT = '2',
  MEDIUM = '3',
  MEDIUM_DARK = '4',
  DARK = '5',
  VERY_DARK = '6',
}

export interface INonConsentData {
  gender: GenderType | null;
  skinTone: SkinToneType | null;
}

export interface IAvaturnAvatarStatus {
  id: string;
  status: string;
}

export interface IUploadUrlItem {
  uploadUrl: string;
  contentType: string;
}

export interface IQrUploadAvatar {
  avatar_id: string;
  user_id: string;
  uploadUrls: [IUploadUrlItem, IUploadUrlItem, IUploadUrlItem];
}
